import React from 'react'
import View from '../../../../../../components/pdf/View'
import Line from '../../../../../../components/pdf/Line'
import Text from '../../../../../../components/pdf/Text'
import Separator from '../../../../../../components/pdf/Separator'

const TableTitle = ({ placeData }) => {
  return (
    <View>
      <Line height={3} color="#333" />

      <Separator weight={1} />

      <Text bold>UNIDADE</Text>
      <Text size={24} bold>
        {placeData.place}
      </Text>
      <Text>{placeData.place}</Text>
      <Text>{placeData.CNPJ}</Text>

      <Separator weight={4} />
    </View>
  )
}

export default TableTitle
